import React, { memo } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { Maybe } from 'types/FMSGraphqlTypes'
import { CheckFilledIcon, VarianceFlagIcon } from 'transfix-icons'
import { Tooltip, brandColors } from 'transfix-ui'

interface ITruckProps {
  truckNumber: Maybe<string>
  truckNeeded: boolean
  vin: Maybe<string>
}

const tooltip = (truckNumber: Maybe<string>, vin: Maybe<string>, truckNeeded: boolean) => {
  if (truckNumber && vin) return `Truck #${truckNumber} · #${vin}`
  if (truckNumber && !vin) return `Truck #${truckNumber}`
  if (truckNeeded) return 'Truck & VIN Needed'
  return 'No Truck · No VIN'
}

const icon = (truckNumber: Maybe<string>, truckNeeded: boolean) => {
  if (truckNumber) return <CheckFilledIcon color='green2' size='xlarge' />
  if (truckNeeded) return <VarianceFlagIcon color='warning1' size='xlarge' />
  return (
    <Typography variant='h3' color={brandColors.coolGray4}>
      –
    </Typography>
  )
}

export const Truck = memo<ITruckProps>(({ truckNeeded, truckNumber, vin }) => {
  const truckIconTooltip = tooltip(truckNumber, vin, truckNeeded)
  const truckIcon = icon(truckNumber, truckNeeded)

  return (
    <Box display='flex'>
      <Tooltip position='top' type='dark' effect='solid' trigger={truckIcon}>
        {truckIconTooltip}
      </Tooltip>
    </Box>
  )
})
